import { FC, ReactNode } from 'react';

interface DisabledFormProps {
  heading: string;
  paragraph: string;
  link?: ReactNode;
  cta?: ReactNode;
}

/**
 * TODO: use this component for disabled borrow form scenarios
 */

export const DisabledForm: FC<DisabledFormProps> = ({ heading, paragraph, link, cta }) => (
  <div className="flex flex-col gap-10">
    <div className="mt-2.5 lg:mt-0 flex flex-col gap-2.5">
      <h2 className="text-base font-medium text-white sm:text-xl">{heading}</h2>
      <p className="text-base text-shale-200">{paragraph}</p>
      {link}
    </div>
    {cta && <div>{cta}</div>}
  </div>
);
